// Extracted from MyPlanTab.js during Phase 4 refactor (sprint 2026-06-20).
// Pure presentational component — receives every dependency via props.
import React from 'react';
import { ClipboardList, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import SelfPlanGenerator from './SelfPlanGenerator';
import DraftPlanEditor from './DraftPlanEditor';

export default function EmptyPlanState({
  fr,
  hasArchivedPlan,
  lastPlanName,
  isCoachOrAdmin,
  showGenerator,
  draftPlan,
  setShowGenerator,
  genForm,
  setGenForm,
  focusOptions,
  generating,
  handleSelfGenerate,
  draftEditorProps,
}) {
  return (
    <div className="space-y-4" data-testid="no-plan">
      {!showGenerator && !draftPlan && (
        <div className="text-center py-12">
          <ClipboardList className="w-12 h-12 text-muted-foreground/30 mx-auto mb-3" />
          <p className="text-muted-foreground font-medium">
            {fr ? 'Aucun plan d\'entraînement actif.' : 'No active training plan.'}
          </p>
          {hasArchivedPlan && (
            <div className="mt-3 mb-4 p-3 bg-amber-500/10 border border-amber-500/20 rounded-lg mx-auto max-w-xs" data-testid="archived-plan-notice">
              <p className="text-xs text-amber-400">
                {fr
                  ? `Ton dernier plan "${lastPlanName}" a ete archive. Ton coach a ete notifie et pourra le restaurer.`
                  : `Your last plan "${lastPlanName}" was archived. Your coach has been notified and can restore it.`}
              </p>
            </div>
          )}
          <p className="text-xs text-muted-foreground/60 mt-1 mb-4">
            {isCoachOrAdmin
              ? (fr ? 'Généré ton propre plan avec l\'IA.' : 'Generate your own plan with AI.')
              : (fr ? 'Ton coach te deploiera un plan personnalise bientot.' : 'Your coach will deploy a custom plan soon.')}
          </p>
          {isCoachOrAdmin && (
            <Button onClick={() => setShowGenerator(true)} data-testid="create-self-plan-btn">
              <Sparkles className="w-4 h-4 mr-2" />
              {fr ? 'Créer mon plan (IA)' : 'Create my plan (AI)'}
            </Button>
          )}
        </div>
      )}
      {showGenerator && !draftPlan && (
        <SelfPlanGenerator
          fr={fr}
          genForm={genForm}
          setGenForm={setGenForm}
          focusOptions={focusOptions}
          generating={generating}
          onGenerate={handleSelfGenerate}
          onCancel={() => setShowGenerator(false)}
        />
      )}
      {draftPlan && <DraftPlanEditor {...draftEditorProps} />}
    </div>
  );
}
